export default function validate({ settings, actions, defaultLanguage = 'en', setErrors }) {
  const validationErrors = []

  actions.forEach(action => {
    if (action.kind === 'survey') {
      let actionConfig = action.config || { thankYouSubject: '', thankYouSenderId: '', thankYouEnabled: false }

      if (actionConfig.thankYouEnabled) {
        if (!actionConfig.thankYouSenderId || actionConfig.thankYouSenderId === '') {
          validationErrors.push("Thank You Email Settings: No sender is selected")
        }
        // Check subject and body fallbacks are available!
        let subject = action.textContent[defaultLanguage]?.thankYouSubject || actionConfig.thankYouSubject
        if (!subject || subject == '') {
          validationErrors.push("Thank You Email Settings: No subject is set")
        }
        let body = action.textContent[defaultLanguage]?.thankYouBody || actionConfig.thankYouBody
        if (!body || body == '') {
          validationErrors.push("Thank You Email Settings: No body is set")
        }
      }
    }
  })

  setErrors(_.uniq(validationErrors))
}
